import { create } from "zustand";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";

export const useAttendanceStore = create((set) => ({
  attendanceReport: [],
  zoneLevelDetails: [],
  supportingStaffDetails: [],
  isFetchingSupportingStaffDetails: false,
  isFetchingSupportingStaffDetailsError: false,
  isFetchingZoneLevelDetails: false,
  isFetchingZoneLevelDetailsError: false,
  isFetchingAttendanceReport: false,
  isFetchingAttendanceReportError: false,

  setIsInnerReportRequested: (val) => {
    set({ isInnerReportRequested: val });
  },
  fetchAttendanceReport: async (queryParams) => {
    set({ isFetchingAttendanceReport: true });
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const attendanceReport = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetAttendanceReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      // Fetch supporting staff attendance
      const supportingStaffResponse = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetSupportingStaffAttendance?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      // Extract supporting staff data
      const supportingStaffData = supportingStaffResponse.length > 0 ? supportingStaffResponse[0] : null;

      // Create Supporting Staff row (Only if data exists)
      const supportingStaffRow = supportingStaffData ? {
          zone: "Supporting Staff",
          plannedAttendance: supportingStaffData.plannedAttendance || 0,
          biometricAttendance: supportingStaffData.biometricAttendance || 0,
          forcedAttendance: supportingStaffData.forcedAttendance || 0,
          bA_FA: supportingStaffData.bA_FA || 0,
          shortfall: supportingStaffData.shortfall || 0,
          attendancePercentage: supportingStaffData.attendancePercentage || 0,
        }
        : null;
        
      const combinedAttendanceReport = [...attendanceReport, supportingStaffRow];

      const totals = combinedAttendanceReport.reduce(
        (acc, item) => {
          acc.plannedAttendance += item.plannedAttendance;
          acc.biometricAttendance += item.biometricAttendance;
          acc.forcedAttendance += item.forcedAttendance;
          acc.bA_FA += item.bA_FA;
          acc.shortfall += item.shortfall;
          acc.attendancePercentage += item.attendancePercentage;
          return acc;
        },
        {
          zone: "Total",
          plannedAttendance: 0,
          biometricAttendance: 0,
          forcedAttendance: 0,
          bA_FA: 0,
          shortfall: 0,
          attendancePercentage: 0,
        }
      );

      // Add Supporting Staff (if exists) before the totals row
      let attendanceReportWithTotals = [...combinedAttendanceReport];
      attendanceReportWithTotals.push(totals);

      set({ attendanceReport: attendanceReportWithTotals });
    } catch (error) {
      set({ isFetchingAttendanceReport: false, isFetchingAttendanceReportError: error });
    } finally {
      set({ isFetchingAttendanceReport: false });
    }
  },

  fetchZoneLevelDetails: async (queryParams) => {
    set({ isFetchingZoneLevelDetails: true });
    console.log("Query Params Before API Call:", queryParams);
    const queryString = new URLSearchParams(queryParams).toString();
    try {
      const zoneLevelDetails = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetZoneLevelDrillDownDetails?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const zoneLevelDetailsWithTotals = [...zoneLevelDetails,];
      set({ zoneLevelDetails: zoneLevelDetailsWithTotals });
    } catch (error) {
      set({
        isFetchingZoneLevelDetailsError: error,
      });
    } finally {
      set({ isFetchingZoneLevelDetails: false });
    }
  },
  fetchSupportingStaffDetails: async (queryParams) => {
    set({ isFetchingSupportingStaffDetails: true });
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const supportingStaffDetails = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetSupportingStaffByDesignation?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({ supportingStaffDetails });
    } catch (error) {
      set({ isFetchingSupportingStaffDetailsError: error });
    } finally {
      set({ isFetchingSupportingStaffDetails: false });
    }
  },
}));
